import { render } from "./HomeActivity.vue?vue&type=template&id=024ad03c&scoped=true"
import script from "./HomeActivity.vue?vue&type=script&lang=js"
export * from "./HomeActivity.vue?vue&type=script&lang=js"

import "./HomeActivity.vue?vue&type=style&index=0&id=024ad03c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-024ad03c"

export default script